// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

[data-neuroglancer-layer-panel-pinned="false"]
  .neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {
  background-color: #393;
}

[data-neuroglancer-layer-visible="false"]
  .neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title
  input {
  text-decoration: line-through;
}

.neuroglancer-layer-side-panel-name {
  flex: 1;
  background-color: transparent;
  border: 0px;
  color: white;
  outline: 0px;
  /* ensure if name gets too long it doesn't push buttons over */
  width: 0px;
  min-width: 0px;
}

.neuroglancer-layer-side-panel-tab-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  font: 10pt sans-serif;
}

.neuroglancer-layer-side-panel-type-measure {
  position: absolute;
  visibility: hidden;
  top: 0px;
  height: auto;
  width: auto;
  white-space: nowrap;
}

.neuroglancer-layer-side-panel-type,
.neuroglancer-layer-side-panel-type-measure {
  padding-left: 3px;
  padding-right: 3px;
  font-weight: bold;
  font-family: sans-serif;
  font-size: 10pt;
  box-sizing: border-box;
}

.neuroglancer-layer-side-panel-type {
  -webkit-appearance: none;
  color: white;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  margin-right: 5px;
  border: 0px;
  outline: 0px;
}

.neuroglancer-layer-side-panel-type option {
  background-color: #000;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/ui/layer_side_panel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;;EAEE,sBAAsB;AACxB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8DAA8D;EAC9D,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/**\n * @license\n * Copyright 2018 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n[data-neuroglancer-layer-panel-pinned=\"false\"]\n  .neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {\n  background-color: #393;\n}\n\n[data-neuroglancer-layer-visible=\"false\"]\n  .neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title\n  input {\n  text-decoration: line-through;\n}\n\n.neuroglancer-layer-side-panel-name {\n  flex: 1;\n  background-color: transparent;\n  border: 0px;\n  color: white;\n  outline: 0px;\n  /* ensure if name gets too long it doesn't push buttons over */\n  width: 0px;\n  min-width: 0px;\n}\n\n.neuroglancer-layer-side-panel-tab-view {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  font: 10pt sans-serif;\n}\n\n.neuroglancer-layer-side-panel-type-measure {\n  position: absolute;\n  visibility: hidden;\n  top: 0px;\n  height: auto;\n  width: auto;\n  white-space: nowrap;\n}\n\n.neuroglancer-layer-side-panel-type,\n.neuroglancer-layer-side-panel-type-measure {\n  padding-left: 3px;\n  padding-right: 3px;\n  font-weight: bold;\n  font-family: sans-serif;\n  font-size: 10pt;\n  box-sizing: border-box;\n}\n\n.neuroglancer-layer-side-panel-type {\n  -webkit-appearance: none;\n  color: white;\n  cursor: pointer;\n  background-color: rgba(0, 0, 0, 0.5);\n  margin-right: 5px;\n  border: 0px;\n  outline: 0px;\n}\n\n.neuroglancer-layer-side-panel-type option {\n  background-color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
